import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { ImportStatusBadge } from "../../components/dealer/InventoryImportShared";
import { useDealerPortalIntl } from "../../hooks/useDealerPortalIntl";
import { useLocale } from "../../intl";
import { fetchDealerImports } from "../../services/automapInventoryImportApi";

export default function DealerInventoryImportHistoryPage() {
  const { dealerId } = useOutletContext();
  const { t, translateError } = useDealerPortalIntl();
  const { locale } = useLocale();
  const [imports, setImports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDealerImports(dealerId)
      .then((data) => setImports(data.imports || []))
      .catch((err) => setError(translateError(err.message, "loadImport")))
      .finally(() => setLoading(false));
  }, [dealerId, translateError]);

  return (
    <div>
      <div className="import-page-header">
        <div>
          <h2>{t("import.historyTitle")}</h2>
          <p className="muted">{t("import.historySubtitle")}</p>
        </div>
        <Link className="dealer-portal-btn primary" to="/v/automap/dealer/inventario/importar">
          {t("import.newImport")}
        </Link>
      </div>

      {error ? <p className="dealer-state-box">{error}</p> : null}
      {loading ? <p className="dealer-state-box">{t("common.loading")}</p> : null}

      {!loading && imports.length === 0 ? (
        <div className="dealer-state-box">
          <p>{t("import.noImports")}</p>
          <Link className="dealer-portal-btn primary" to="/v/automap/dealer/inventario/importar">
            {t("import.importInventory")}
          </Link>
        </div>
      ) : null}

      {!loading && imports.length > 0 ? (
        <table className="dealer-inventory-table">
          <thead>
            <tr>
              <th>{t("import.tableDate")}</th>
              <th>{t("import.tableFile")}</th>
              <th>{t("import.tableStatus")}</th>
              <th>{t("import.tableRows")}</th>
              <th>{t("import.tableCreated")}</th>
              <th>{t("import.tableUpdated")}</th>
              <th>{t("import.tableSkipped")}</th>
              <th>{t("import.tableErrors")}</th>
              <th>{t("import.tableUploadedBy")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {imports.map((item) => (
              <tr key={item.id}>
                <td>{new Date(item.createdAt).toLocaleString(locale)}</td>
                <td>{item.sourceFilename}</td>
                <td>
                  <ImportStatusBadge status={item.status} />
                </td>
                <td>{item.totalRows}</td>
                <td>{item.createdCount}</td>
                <td>{item.updatedCount}</td>
                <td>{item.skippedCount}</td>
                <td>{item.errorCount}</td>
                <td>{item.uploadedByLabel || "—"}</td>
                <td>
                  <Link to={`/v/automap/dealer/inventario/importar/${item.id}`}>{t("import.viewDetail")}</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </div>
  );
}
